export default __webpack_public_path__ + "static/media/paseo-wynwood.97cd205c.svg";